var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"age"},[(!_vm.hasLoaded)?_c('loader',{attrs:{"height":200}}):_c('div',{staticClass:"chart"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }